import { cva, type VariantProps } from 'class-variance-authority';

export const typographyVariants = cva([], {
  variants: {
    variant: {
      display1: ['text-5xl', 'md:text-7xl', 'leading-11', 'md:leading-13'],
      display2: ['text-4xl', 'md:text-6xl', 'leading-9', 'md:leading-12'],
      display3: ['text-3xl', 'md:text-5xl', 'leading-7', 'md:leading-11'],
      display4: ['text-2xl', 'md:text-4xl', 'leading-6', 'md:leading-10'],
      display5: ['text-3xl', 'md:text-3xl', 'leading-5', 'md:leading-8'],
      display6: ['text-lg', 'md:text-xl', 'leading-4', 'md:leading-4'],
      'body-l': ['text-base', 'md:text-lg', 'leading-3', 'md:leading-4'],
      'body-m': ['text-sm', 'md:text-base', 'leading-2', 'md:leading-3'],
      'body-s': ['text-xs', 'md:text-sm', 'leading-1', 'md:leading-2'],
      'body-xs': ['text-2xs', 'md:text-xs', 'leading-0', 'md:leading-1'],
      'body-xxs': ['text-3xs', 'leading-0'],
    },
    weight: {
      bold: ['font-bold'],
      semibold: ['font-semibold'],
      medium: ['font-medium'],
      regular: ['font-extralight'],
    },
    useCase: {
      button: ['leading-1', 'md:leading-1'],
    },
  },
});

export function getTypographyVariantClasses(
  variant: TypographyVariants['variant'],
): string {
  return typographyVariants({ variant });
}

export type TypographyVariants = VariantProps<typeof typographyVariants>;
